import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';


const pdfMime = /\/pdf/;
const wordMime = /word|opendocument/;
const excelMime = /excel|sheet/;
const imageMime = /image\//;

// <i class="lar la-file-excel"></i>
// <i class="las la-file-word"></i>
// <i class="las la-file-image"></i>
// <i class="las la-file-pdf"></i>

const getClassByMime = (mime) => {
  switch (true) {
    case pdfMime.test(mime):
      return 'la la-file-pdf';
    case wordMime.test(mime):
      return 'la la-file-word';
    case imageMime.test(mime):
      return 'la la-file-image';
    case excelMime.test(mime):
      return 'la la-file-excel';
    default:
      return 'la la-file';
  }
};

const FileIcon = ({ mime, className }) => <i className={cn(getClassByMime(mime), className)} />;

FileIcon.propTypes = {
  mime: PropTypes.string,
  className: PropTypes.string,
};

FileIcon.defaultProps = {
  mime: null,
  className: null,
};

export default FileIcon;
